<script lang="ts">
  import type { NvrInfo } from '../lib/types';

  type Props = {
    nvr?: NvrInfo;
    /** "All cameras" pseudo-item if no nvr passed. */
    isAll?: boolean;
    allCount?: number;
    active?: boolean;
    onclick?: () => void;
    onmenuclick?: (anchor: HTMLElement) => void;
  };
  let { nvr, isAll = false, allCount = 0, active = false, onclick, onmenuclick }: Props = $props();

  const dotColor = $derived(
    nvr
      ? nvr.online_count === nvr.stream_count
        ? 'var(--ok)'
        : nvr.online_count > 0
          ? 'var(--accent)'
          : 'var(--bad)'
      : 'var(--fg-faint)',
  );
</script>

<div
  class="item"
  class:active
  role="button"
  tabindex="0"
  onclick={onclick}
  onkeydown={(e) => {
    if (e.key === 'Enter') onclick?.();
  }}
>
  <span class="icon">
    {#if isAll}
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <rect x="3" y="3" width="7" height="7" rx="1"/>
        <rect x="14" y="3" width="7" height="7" rx="1"/>
        <rect x="3" y="14" width="7" height="7" rx="1"/>
        <rect x="14" y="14" width="7" height="7" rx="1"/>
      </svg>
    {:else}
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M23 7l-7 5 7 5V7z"/>
        <rect x="1" y="5" width="15" height="14" rx="2"/>
      </svg>
    {/if}
  </span>
  <span class="name" title={nvr?.note ?? ''}>
    {nvr?.name ?? 'Все камеры'}
  </span>
  <span class="meta" style:color={dotColor}>
    {nvr ? `${nvr.online_count}/${nvr.stream_count}` : allCount}
  </span>
  {#if !isAll && onmenuclick}
    <button
      class="more"
      type="button"
      title="Меню"
      onclick={(e) => {
        e.stopPropagation();
        onmenuclick(e.currentTarget as HTMLElement);
      }}
    >
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="5" r="1.6" />
        <circle cx="12" cy="12" r="1.6" />
        <circle cx="12" cy="19" r="1.6" />
      </svg>
    </button>
  {/if}
</div>

<style>
  .item {
    display: flex; align-items: center; gap: 10px;
    width: 100%; padding: 8px 10px; border-radius: var(--radius-sm);
    color: var(--fg-muted);
    transition: background .15s, color .15s;
    white-space: nowrap;
    position: relative;
  }
  .item:hover { background: rgba(127,127,127,.08); color: var(--fg); }
  .item.active { background: var(--accent); color: #fff; }
  .item.active .meta { color: rgba(255,255,255,.85); }
  .icon { width: 20px; height: 20px; flex-shrink: 0; display: grid; place-items: center; }
  .icon :global(svg) { width: 16px; height: 16px; }
  .name { flex: 1; font-weight: 500; overflow: hidden; text-overflow: ellipsis; }
  .meta { font-size: 11px; color: var(--fg-faint); font-variant-numeric: tabular-nums; }
  .more {
    width: 22px; height: 22px; flex-shrink: 0;
    display: none; place-items: center; border-radius: 4px;
    color: inherit; opacity: .55;
  }
  .more :global(svg) { width: 14px; height: 14px; }
  .item:hover .more { display: grid; }
  .more:hover { background: rgba(0,0,0,.18); opacity: 1; }
  :global(body.sidebar-collapsed) .name,
  :global(body.sidebar-collapsed) .meta,
  :global(body.sidebar-collapsed) .more { opacity: 0; pointer-events: none; }
</style>
